import styled from 'shared/utils/styled';

type StatusAccessories = Partial<{
  status: number;
}>;

export const Status = styled('span')<StatusAccessories>(({ status }) => ({
  ...(status === 1 && {
    fontWeight: 600,
  }),
}));
